import React, { useState, useEffect } from 'react'
import { graphql, compose } from 'react-apollo'

import Toolbar from '../Toolbar'
import pubSub from '../../lib/util/pubSub'
import { Container } from './topNav.styled'
import HamburgerMenu from '../HamburgerMenu'
import { isAmwellTheme } from '../../lib/util'
import { GET_DICTATION } from '../../apollo/actions'
import { isEmrIntegrationToolBarVisible } from '../../helpers/emrIntegration'
import { EMR_INTEGRATION_DETAILS_UPDATE } from '../../constants/pubSub.events'

const TopNav = (props) => {
  const [emrIntegrationToolBarVisible, setEmrIntegrationToolBarVisibility] =
    useState(isEmrIntegrationToolBarVisible())

  const handleEmrIntegrationDetailsUpdate = () => {
    setEmrIntegrationToolBarVisibility(isEmrIntegrationToolBarVisible())
  }

  useEffect(() => {
    const subscription = pubSub.subscribe(
      EMR_INTEGRATION_DETAILS_UPDATE,
      handleEmrIntegrationDetailsUpdate
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const isAmwellDark = isAmwellTheme()

  if (isAmwellDark) return null

  const marginTop = emrIntegrationToolBarVisible ? '44px' : '0px'
  /* LDA-25 is the reason for having "HamburgerMenu" and "Toolbar" peers to "Container" instead of children of d"Container" */
  return (
    <>
      <Container
        id='appTopNav'
        emrIntegrationToolBarVisible={emrIntegrationToolBarVisible}
        dictation={props.dictation}
      />
      <HamburgerMenu
        key='HamburgerMenu'
        history={props.history}
        marginTop={marginTop}
      />
      <Toolbar key='ToolBar' history={props.history} marginTop={marginTop} />
    </>
  )
}

export default compose(
  graphql(GET_DICTATION, {
    props: ({ data: { dictation } }) => ({
      dictation
    })
  })
)(TopNav)
